// Class: haxe.xml._Fast.NodeAccess

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $import = require("./../../../import_stub").default;
function Xml() {return require("./../../../Xml");}
function js__$Boot_HaxeError() {return require("./../../../js/_Boot/HaxeError");}
function haxe_xml_Fast() {return require("./../../../haxe/xml/Fast");}

// Constructor

var NodeAccess = function(x) {
	this.__x = x;
}

// Meta

NodeAccess.__name__ = ["haxe","xml","_Fast","NodeAccess"];
NodeAccess.prototype = {
	resolve: function(name) {
		var x = this.__x.elementsNamed(name).next();
		if(x == null) {
			var xname = this.__x.nodeType == (Xml().default).Document ? "Document" : this.__x.get_nodeName();
			throw new (js__$Boot_HaxeError().default)(xname + " is missing element " + name);
		}
		return new (haxe_xml_Fast().default)(x);
	}
};
NodeAccess.prototype.__class__ = NodeAccess.prototype.constructor = $hxClasses["haxe.xml._Fast.NodeAccess"] = NodeAccess;

// Init



// Statics




// Export

exports.default = NodeAccess;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/haxe/xml/_Fast/NodeAccess.js
// module id = 307
// module chunks = 0